import React from 'react';
import Heading from 'components/Heading';
import Row from 'components/Row';
import Text from 'components/Text';

type Props = {
  children: React.ReactNode;
  // size only impacts the spacing below the heading
  size?: 'small' | 'medium';
};

export default function CoachingHeading(props: Props) {
  return (
    <Row size={props.size ?? 'small'}>
      <Heading level="1" serif flush>
        <Text color="ink">{props.children}</Text>
      </Heading>
    </Row>
  );
}
